<template>
  <div class="SpPagenation">
    <div v-if="pages" class="sp-pagenation-content">
      <SpIcon title="第一页" type="pageLeftDouble" class="page-icon" @click="changePage(1)" />
      <SpIcon title="上一页" type="pageLeft" class="page-icon" @click="changePage(currPage-1)" />

      <template v-for="(page,key,index) in pages" :key="'pagenation-'+index">
        <div v-if="page/1>0" :class="{'sp-color-bg-3':page==currPage}" class="page-button sp-color-7 sp-color-bd-3 sp-color-bg-hover-3 text-center" @click="changePage(page)">{{ page }}</div>
        <div v-if="page/1==0" class="sp-color-7">...</div>
      </template>

      <SpIcon title="下一页" type="pageLeft" class="page-icon-right" @click="changePage(currPage+1)" />
      <SpIcon title="最后一页" type="pageLeftDouble" class="page-icon-right" @click="changePage(-1)" />
      <span class="jump-to sp-color-7">跳转</span>
      <SpSelect v-model="currentPage" width="50" height="20" :pop-style="{borderRadius:'2px'}">
        <SpSelectOption v-for="page in Math.ceil(total / pageSize)" :key="'page-select'+page" :value="page"><div class="select-option">第{{ page }}页</div></SpSelectOption>
      </SpSelect>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import SpIcon from './SpIcon.vue'
import SpSelect from './SpSelect.vue'
import SpSelectOption from './SpSelectOption.vue'
export default {
  name: 'SpPagenation',

  nameSpace: 'SpPagenation',

  components: {
    SpIcon,
    SpSelect,
    SpSelectOption
  },

  props: {

    currPage: {
      type: Number,
      default: 1
    },

    total: {
      type: Number,
      default: 0
    },

    pageSize: {
      type: Number,
      default: 10
    }
  },

  emits: ['update:currPage', 'change-currpage'],

  data () {
    return {
    }
  },

  computed: {

    pages () {
      const totalPage = Math.ceil(this.total / this.pageSize)
      if (totalPage < 2) {
        return null
      }
      let pages = []
      if (totalPage <= 11) {
        for (let i = 1; i <= totalPage; i++) {
          pages.push(i)
        }
      } else {
        pages = [
          1,
          2,
          this.currPage <= 5 ? 3 : -1,
          this.currPage <= 5 ? 4 : -1,
          this.currPage <= 5 ? 5 : -1,
          this.currPage <= 5 ? 6 : -1,
          this.currPage <= 5 ? 7 : -1,
          0,
          this.currPage > 5 && this.currPage < totalPage - 4 ? this.currPage - 2 : -1,
          this.currPage > 5 && this.currPage < totalPage - 4 ? this.currPage - 1 : -1,
          this.currPage > 5 && this.currPage < totalPage - 4 ? this.currPage : -1,
          this.currPage > 5 && this.currPage < totalPage - 4 ? this.currPage + 1 : -1,
          this.currPage > 5 && this.currPage < totalPage - 4 ? this.currPage + 2 : -1,
          0,
          this.currPage >= totalPage - 4 ? totalPage - 6 : -1,
          this.currPage >= totalPage - 4 ? totalPage - 5 : -1,
          this.currPage >= totalPage - 4 ? totalPage - 4 : -1,
          this.currPage >= totalPage - 4 ? totalPage - 3 : -1,
          this.currPage >= totalPage - 4 ? totalPage - 2 : -1,
          totalPage - 1,
          totalPage
        ]
      }

      const list = {}
      for (const key in pages) {
        list[key] = pages[key]
      }
      return list
    },

    currentPage: {
      get () {
        return this.currPage
      },

      set (nv) {
        this.changePage(nv)
      }
    }
  },

  created () {
  },

  mounted () {
  },

  methods: {
    changePage (page) {
      const total = Math.ceil(this.total / this.pageSize)
      if (page === -1 || page > total) {
        page = total
      }
      if (page === 0) {
        page = 1
      }
      this.$emit('update:currPage', page)
      this.$emit('change-currpage', page)
    }
  }
}
</script>

 <style scoped lang="less">
 .SpPagenation{
   display: flex;
   justify-content: flex-end;
   margin-right: @gap*2;
   .sp-pagenation-content{
     display: flex;
     margin-top: 30px;
   }
   .page-icon{
     width: 20px;
     height:20px;
     cursor: pointer;
   }
   .page-icon-right{
     width: 20px;
     height:20px;
     cursor: pointer;
     transform: rotate(180deg);
   }
   .page-button{
     cursor: pointer;
     margin: 0 5px;
     width: 20px;
     height:20px;
     border-style: solid;
     border-width: 1px;
     line-height: 20px;
     border-radius: 4px;
   }
   .jump-to{
     font-size: 14px;
     margin: 0 @gap/2 0 @gap;
   }
 }
.select-option{
  padding: 5px;
}
 </style>
